import { FC } from 'react'
import { observer } from 'mobx-react'
import { IPublicCompany } from '@/types'
import { SnsLinkIconGroup } from '@/components/atoms/SnsLinkIconGroup'
import { FollowingFollowersItem } from '@/components/molecules/FollowingFollowersItem'
import { Tag } from '@/components/atoms/Tag'
import styles from './index.module.scss'

type Props = {
  company: IPublicCompany
}

export const CompanyDetailHeaderInfo: FC<Props> = observer(({ company }) => {
  return (
    <div className={styles.content}>
      <div className={styles.name}>{company.name}</div>
      {!company?.isVc && company?.markets.length > 0 && (
        <div className={styles.market_list}>
          {company?.markets.map((market) => (
            <div key={market.id} className={styles.marketTag__item}>
              <Tag>{market.name}</Tag>
            </div>
          ))}
        </div>
      )}
      <div className={styles.following_followers}>
        <FollowingFollowersItem
          followersCount={company?.followersCount}
          linkTofollowers={`/companies/${company?.slug}/followers`}
        />
      </div>
      <div className={styles.snsIconGroup}>
        <SnsLinkIconGroup
          twitterUrl={company?.twitterUrl}
          facebookUrl={company?.facebookUrl}
          instagramUrl={company?.instagramUrl}
          linkedInUrl={company?.linkedinUrl}
          telegramUrl={company?.telegramUrl}
          openseaUrl={company?.openseaUrl}
          discordUrl={company?.discordUrl}
        />
      </div>
    </div>
  )
})
